import React, { Component } from 'react'
import { css } from 'emotion'
import { NavbarView } from 'components'
import { MEDIA_QUERY } from 'styles'
import { LocationSelect, Logo } from 'cf-web-app/components'
import { mountainbg2, navbg } from 'images'

class PageHeader extends Component {
  render() {
    return (
      <div className={styles.container}>
        <div className={styles.innerContainer}>
          <div className={styles.location}>
            <Logo />
            <LocationSelect />
          </div>
          <NavbarView />
        </div>
      </div>
    )
  }
}

const styles = {
  container: css({
    width: '100%',
    height: '9rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: `url(${navbg}) no-repeat`,
    backgroundSize: 'cover',
    boxShadow: '1px 1px 5px rgba(0,0,0,.7)',
    [MEDIA_QUERY.SM]: {
      background: `url(${mountainbg2}) no-repeat`,
      backgroundSize: 'cover',
      backgroundPosition: 'bottom',
      height: '13rem',
    },
  }),
  innerContainer: css({
    width: '90%',
    height: '100%',
    maxWidth: '116rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [MEDIA_QUERY.SM]: {
      paddingTop: '2rem',
      flexDirection: 'column',
      height: '13rem',
    },
  }),
  location: css({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [MEDIA_QUERY.SM]: {
      flexDirection: 'column',
    },
  }),
}

export default PageHeader
